import { Box, Typography } from '@mui/material'
import ColoredTooltip from 'src/components/Tooltip/ColoredTooltip'

const ErrorTag = ({ tag }: { tag: string }) => {
  return (
    <ColoredTooltip title={tag.length > 30 ? tag : null}>
      <Box
        border="1px solid #E6E6E6"
        borderRadius="13px"
        height="26px"
        px={1.5}
        display="flex"
        alignItems="center"
        maxWidth="200px">
        <Typography
          fontSize={12}
          color="#000"
          noWrap>
          {tag}
        </Typography>
      </Box>
    </ColoredTooltip>
  )
}

export default ErrorTag
